module.exports = __webpack_public_path__ + "static/fonts/UniversLTStd.ae3232c.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/UniversLTStd.otf
// module id = Hm52
// module chunks = 1